import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { callListReportRecords } from './report.action';

@Injectable({ providedIn: 'root' })
export class CallListReportTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                id: '',
                created_at: '',
                member_number: '',
                debtor_name: '',
                debtor_phone: '',
                debtor_phone_other: '',
                date_of_birth: '',
                team: '',
                dossier_categories_name: null,
                club_name: null,
                principle_with_fee: '',
                nikki_fee: '',
                already_paid: '',
                outstanding_with_fee: ''
            };

    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'season_name';
    initialSortDirection = 'desc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    hasFilter = false;
    clubs = [];
    categories = [];
   

    columns = [
                { prop: 'id', name: 'REPORTS.dossier-id', sortable: true, hasFilter: true, filter: "input", widthSet: 100},
                { prop: 'created_at', name: 'COMMON.created-date', sortable: true, hasFilter: true, filter: "date", widthSet: 155},
                { prop: 'member_number', name: 'REPORTS.member-number', sortable: true, hasFilter: true, filter: "input", widthSet: 125},
                { prop: 'debtor_name', name: 'REPORTS.debtor-name', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'debtor_phone', name: 'REPORTS.phone', sortable: true, hasFilter: true, filter: "input", widthSet: 120},
                { prop: 'debtor_phone_other', name: 'REPORTS.secondary-phone', sortable: true, hasFilter: true, filter: "input", widthSet: 130},
                { prop: 'date_of_birth', name: 'REPORTS.date-of-birth', sortable: true, hasFilter: true, filter: "date", widthSet: 155},
                { prop: 'team', name: 'REPORTS.team', sortable: true, hasFilter: true, filter: "input", widthSet: 110},
                { prop: 'dossier_categories_name', name: 'REPORTS.category', sortable: true, hasFilter: true, filter: "select", options: 'categories', options_id: "id", options_label: "name", widthSet: 150},
                { prop: 'club_name', name: 'REPORTS.club', sortable: true, hasFilter: true, filter: "select", options: 'clubs', options_id: "id", options_label: "club_name", widthSet: 180},
                { prop: 'principle_with_fee', name: 'REPORTS.principal-amount', sortable: true, hasFilter: true, filter: "input", widthSet: 110},
                { prop: 'nikki_fee', name: 'REPORTS.service-cost', sortable: true, hasFilter: true, filter: "input", widthSet: 110},
                { prop: 'already_paid', name: 'REPORTS.already-paid', sortable: true, hasFilter: true, filter: "input", widthSet: 110},
                { prop: 'outstanding_with_fee', name: 'REPORTS.outstanding', sortable: true, hasFilter: true, filter: "input", widthSet: 110}
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(callListReportRecords());
    }

    hasActiveFilters(){
        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetState(){
        this.filters = {
            id: '',
            created_at: '',
            member_number: '',
            debtor_name: '',
            debtor_phone: '',
            debtor_phone_other: '',
            date_of_birth: '',
            team: '',
            dossier_categories_name: null,
            club_name: null,
            principle_with_fee: '',
            nikki_fee: '',
            already_paid: '',
            outstanding_with_fee: ''
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;
    }

    resetFilters(){
        this.resetState();
        this.loadRecords();
    }

}